import { isNil, toLower } from 'lodash';
import apiRoutes from './routes';

const env = process.env.VUE_APP_ENV || process.env.VUE_APP_SERVER || process.env.NODE_ENV || 'staging';
const routes = Object.assign(apiRoutes.common, apiRoutes[env]);

// Environments and DCs can be mixed somewhere
const envMapper = {
  dev: 'dev',
  develop: 'dev',
  sta: 'staging',
  staging: 'staging',
  master: 'production',
  prod: 'production',
  production: 'production',
  'dc-en': 'production',
  london: 'production',
  ro: 'production',
  'dc-ro': 'production',
  ro2: 'production',
  'dc-ro2': 'production',
  rs: 'production',
  'dc-rs': 'production',
  rs2: 'production',
  'dc-rs2': 'production',
  de: 'production',
  'dc-de': 'production',
};

const formatDc = (dc) => {
  const dcParsed = dc && dc.match(/-([a-zA-Z0-9]*)/);

  return toLower(dcParsed ? dcParsed[1] : dc);
};

const getApiRoute = (routeName, routeEnv, routeDc) => {
  const environment = toLower(envMapper[routeEnv]);
  const dataCenter = routeDc && formatDc(routeDc);

  // TODO: rewrite to optional chaining (?.) when resolved Babel issues for app importing SDK
  if (!isNil(environment) && !isNil(apiRoutes[environment])) {
    if (
      !isNil(dataCenter) &&
      !isNil(apiRoutes[environment].dcSpecific) &&
      !isNil(apiRoutes[environment].dcSpecific[dataCenter]) &&
      !isNil(apiRoutes[environment].dcSpecific[dataCenter][routeName])
    ) {
      return apiRoutes[environment].dcSpecific[dataCenter][routeName];
    } else if (!isNil(apiRoutes[environment][routeName])) {
      return apiRoutes[environment][routeName];
    }
  }

  return routes[routeName];
};

export { env, routes, getApiRoute };
